<template>
  <div id="product-view">

    <h2 class="product-title font-weight-bold">{{product.title}}</h2>
    
    <div class="container">

      <div class="row py-3">
        <div class="col-sm-3 col-centered text-left">
          <p>가격 ₩{{parsedPrice}}</p>
          <p>원산지: {{product.originCountry}}</p>
          <p>제작년도: {{product.year}}년</p>
          <p>재고 수량: {{}}</p>
          <p>사이즈 {{product.x}}cm x {{product.y}}cm x {{product.z}}cm</p>
          <p>현재위치: {{}}</p>
          <p>
            수량
            <select id="quantity-selector">
              <option value="1" selected="selected">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </p>
          <h4 class="font-weight-bold">₩{{parsedPrice}}</h4>
          <button type="button" class="btn btn-primary">구매하기</button>
          <!-- <button type="button" class="btn btn-primary">장바구니로 이동</button> -->
          <img src="@/assets/img/consult_small_yellow_pc.png">
        </div>
        <div class="col-sm-3 col-centered text-left">
          <h4>지역별 배송요금</h4>
          <p>서울/경기: 별도문의</p>
          <p>충정/강원: 별도문의</p>
          <p>전라: 별도문의</p>
          <p>경상: 별도문의</p>
        </div>
      </div>

      <!-- TODO nav true 미적용 체크 -->
      <div class="my-5">
        <carousel
          :margin="10"
          :loop="true"
          :nav="true"
          :autoplay="true"
          :mouseDrag="true">
          <img v-for="(image, index) in images" :key="index" :src="image">
        </carousel>
      </div>

      <!-- modal (장바구니 담겼음 메시지) -->
      <!-- ... -->

    </div> <!-- ./container -->

  </div>
</template>

<script>
// https://github.com/s950329/vue-owl-carousel
import carousel from 'vue-owl-carousel'

export default {
  name: 'ProductDetailView',
  components: {
    carousel,
  },
  props: {
    productId: Number,
  },
  computed: {
    product() {
      return this.$store.state.products.currentProduct;
    },
    parsedPrice() {
      return this.$store.state.products.currentProduct.price.toLocaleString();
    },
    images() {
      return this.$store.state.products.currentProduct.imageUrls.split(',')
    },
  },
  created() {
    this.updateProduct();
    $('body');
  },
  methods: {
    updateProduct() {
      this.$store.dispatch('requestCurrentProductById', this.productId);
    },
  },
}
</script>

<style scoped>
.col-centered {
  display: block;
  float: none;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/views/ProductDetailView.vue